/*
 * The looks page (27-10-2026; sections/main-looks.liquid). Three things, the cart itself stays with
 * assets/theme.js:
 * - filters: with or without a coat, and a colour; a look shows when it carries every chosen tag;
 * - the panel of a look in the dialog: opened from the card, or from the link of a collection tile (#<look id>), with
 *   the size once for the whole outfit or per piece and a tick to leave a piece out; the total, what he saves and
 *   the gifts follow what is checked (each gift once; the free accent once the hero and one more piece are in);
 * - before the theme adds the outfit (its submit handler on data-product-form, Cart.add) every checked piece needs a
 *   size; when the drawer opens, the dialog steps aside;
 * - the maatcoach for the whole outfit (28-10-2026): a line under the sizes opens it, and every piece takes its own
 *   advised size.
 */
(function () {
  var root = document.querySelector('[data-looks]');
  if (!root) return;
  var T = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var text = function (k) { return root.getAttribute('data-text-' + k) || ''; };

  /* The money format of the theme (layout/theme.liquid, window.theme.moneyFormat), as assets/theme.js formats it. */
  function money(cents) {
    var format = T.moneyFormat || '{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var decimals = key.indexOf('no_decimals') > -1 ? 0 : 2;
    var thousands = ',', decimal = '.';
    if (key.indexOf('comma_separator') > -1) { thousands = '.'; decimal = ','; }
    if (key.indexOf('space_separator') > -1) { thousands = ' '; decimal = ','; }
    if (key.indexOf('apostrophe_separator') > -1) { thousands = "'"; decimal = '.'; }
    var parts = ((Number(cents) || 0) / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return format.replace(/\{\{\s*\w+\s*\}\}/, parts.join(decimal));
  }

  /* ---- filters ---------------------------------------------------------------------------- */
  var cards = $$('[data-look]', root);
  var chosen = {};
  function filter() {
    var shown = 0;
    cards.forEach(function (card) {
      var tags = card.getAttribute('data-tags') || ' ';
      var ok = Object.keys(chosen).every(function (g) { return !chosen[g] || tags.indexOf(' ' + chosen[g] + ' ') > -1; });
      card.hidden = !ok;
      if (ok) shown++;
    });
    var count = $('[data-looks-count]', root);
    if (count) count.textContent = shown;
    var empty = $('[data-looks-empty]', root);
    if (empty) empty.hidden = shown > 0;
  }
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-filter]');
    if (!chip) return;
    var group = chip.closest('[data-filter-group]');
    var name = group.getAttribute('data-filter-group');
    var value = chip.getAttribute('data-filter');
    /* A colour chip pressed again lets go; "Tous" clears the coat. */
    if (chip.getAttribute('aria-pressed') === 'true' && value) value = '';
    chosen[name] = value;
    $$('[data-filter]', group).forEach(function (c) {
      c.setAttribute('aria-pressed', String(c.getAttribute('data-filter') === value && (value !== '' || name === 'coat')));
    });
    filter();
  });

  /* ---- the panel of a look ---------------------------------------------------------------- */
  var dialog = $('[data-look-dialog]', root);
  var slot = $('[data-look-slot]', root);
  var current = null, home = null;

  function update(panel) {
    var rows = $$('[data-piece]', panel);
    var on = [], heroOn = false, sum = 0, saved = 0, gifts = {};
    rows.forEach(function (row) {
      if (row.hasAttribute('data-accent')) return;
      var box = $('[data-piece-on]', row);
      var active = !box || box.checked;
      row.classList.toggle('is-off', !active);
      $$('select, input[type="hidden"]', row).forEach(function (i) { i.disabled = !active; });
      if (!active) return;
      on.push(row);
      var sel = $('[data-piece-size]', row);
      var opt = sel && sel.value ? sel.options[sel.selectedIndex] : null;
      var price = Number((opt && opt.getAttribute('data-price')) || row.getAttribute('data-price')) || 0;
      var was = Number((opt && opt.getAttribute('data-was')) || row.getAttribute('data-was')) || 0;
      sum += price;
      if (was > price) saved += was - price;
      if (row.hasAttribute('data-hero')) heroOn = true;
      var g = row.getAttribute('data-gift');
      if (g) gifts[g] = Number(row.getAttribute('data-gift-value')) || 0;
    });
    /* Gifts only with the complete outfit, while the offer is open (eigenaar 27-10-2026: "alleen bij complete outfit"; the
       cart, GiftRules with tenueLooks): every piece checked, otherwise no gifts and no free accent, and the box says why.
       data-gifts-ok is 0 when the offer is over or a piece of the outfit cannot be bought: then no gifts at all. */
    var giftsOk = panel.getAttribute('data-gifts-ok') === '1';
    var complete = rows.every(function (row) { return row.hasAttribute('data-accent') || !$('[data-piece-on]', row) || $('[data-piece-on]', row).checked; });
    if (!giftsOk || !complete) gifts = {};
    var acc = $('[data-piece][data-accent]', panel);
    if (acc) {
      var accOn = giftsOk && complete;
      acc.classList.toggle('is-off', !accOn);
      var ag = acc.getAttribute('data-gift');
      if (accOn && ag) gifts[ag] = Number(acc.getAttribute('data-gift-value')) || 0;
    }
    var n = 0, giftValue = 0;
    Object.keys(gifts).forEach(function (k) { n++; giftValue += gifts[k]; });
    $$('[data-gift-item]', panel).forEach(function (li) { li.hidden = !(li.getAttribute('data-gift-item') in gifts); });
    var box = $('[data-look-gifts]', panel);
    if (box) {
      box.hidden = !giftsOk;
      box.classList.toggle('is-incomplete', giftsOk && !complete);
    }
    var note = $('[data-look-gifts-note]', panel);
    if (note) note.textContent = note.getAttribute(complete ? 'data-text-complete' : 'data-text-incomplete');
    var gt = $('[data-look-gifts-text]', panel);
    if (gt) gt.textContent = n === 1 ? text('gifts-one') : text('gifts-other').replace('%count%', n);
    var gv = $('[data-look-gifts-value]', panel);
    if (gv) gv.textContent = money(giftValue);
    var gf = $('[data-look-gifts-free]', panel);
    if (gf) gf.textContent = n === 1 ? text('free-one') : text('free-other');
    var total = $('[data-look-total]', panel);
    if (total) total.textContent = money(sum);
    var pieces = $('[data-look-pieces]', panel);
    if (pieces) pieces.textContent = text('pieces-one').replace('%count%', on.length);
    var save = $('[data-look-save]', panel);
    if (save) {
      save.hidden = saved + giftValue <= 0;
      save.textContent = text('save').replace('%amount%', money(saved + giftValue));
    }
    var add = $('[data-add-button]', panel);
    if (add) add.disabled = on.length === 0;
    /* The question for a size goes once every checked piece has one. */
    var err = $('[data-look-error]', panel);
    if (err && err.textContent && !$$('[data-piece-size]', panel).some(function (s) { return !s.disabled && !s.value; })) err.textContent = '';
  }

  /* The size once for the whole outfit: the sizes the selects of this look offer, clothes (letters) and shoes (numbers)
     each on one row, smallest first (XXS ... 5XL, 35 ... 42; eigenaar 27-10-2026: "zorg dat alles strak is en niks
     overloopt ... bij maten bedenk hier een handigheid voor"): one bar of equal cells that never wraps. Pressing one sets
     every checked piece that has it, and the size is remembered for the other looks (this browser, localStorage). */
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL'];
  function rank(s) {
    var u = String(s).toUpperCase().replace(/\s+/g, '').replace(/^2XL$/, 'XXL').replace(/^XXXL$/, '3XL');
    var i = ORDER.indexOf(u);
    return i === -1 ? ORDER.length : i;
  }
  var KEY = 'lk-sizes';
  function remembered() { try { return JSON.parse(window.localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function remember(row, size) {
    try { var m = remembered(); m[row] = size; window.localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {}
  }
  function sizes(panel) {
    var wrap = $('[data-look-sizes]', panel);
    var chips = $('[data-look-size-chips]', panel);
    if (!wrap || !chips || chips.childElementCount) return;
    var rows = { clothes: [], shoes: [] };
    $$('[data-piece-size] option[data-size]', panel).forEach(function (o) {
      var s = o.getAttribute('data-size');
      var row = /^\d+([.,]\d+)?$/.test(s) ? rows.shoes : rows.clothes;
      if (s && row.indexOf(s) === -1) row.push(s);
    });
    rows.clothes.sort(function (a, b) { return rank(a) - rank(b); });
    rows.shoes.sort(function (a, b) { return parseFloat(a.replace(',', '.')) - parseFloat(b.replace(',', '.')); });
    var any = false;
    [['clothes', text('size')], ['shoes', text('shoe')]].forEach(function (r) {
      if (!rows[r[0]].length) return;
      any = true;
      var line = document.createElement('div');
      line.className = 'lk-size__row';
      line.setAttribute('data-size-row', r[0]);
      var label = document.createElement('span');
      label.className = 'lk-size__label';
      label.textContent = r[1];
      line.appendChild(label);
      var set = document.createElement('span');
      set.className = 'lk-size__set';
      set.style.setProperty('--n', rows[r[0]].length);
      rows[r[0]].forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lk-size__chip';
        b.setAttribute('data-size-pick', s);
        b.setAttribute('aria-pressed', 'false');
        b.textContent = s;
        set.appendChild(b);
      });
      line.appendChild(set);
      chips.appendChild(line);
    });
    var hint = document.createElement('p');
    hint.className = 'lk-size__hint';
    hint.setAttribute('data-size-hint', '');
    hint.textContent = text('size-saved');
    hint.hidden = true;
    chips.appendChild(hint);
    wrap.hidden = !any;
  }
  /* A size pressed (or remembered): the bar shows it, and every checked piece with that size takes it; a remembered size
     only fills the pieces that have no size yet, so what she chose per piece stays. */
  function pick(panel, btn, onlyEmpty) {
    var size = btn.getAttribute('data-size-pick');
    var row = btn.closest('[data-size-row]');
    $$('[data-size-pick]', row || panel).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
    $$('[data-piece-size]', panel).forEach(function (sel) {
      if (sel.disabled || (onlyEmpty && sel.value)) return;
      var match = $$('option', sel).filter(function (o) { return o.getAttribute('data-size') === size && !o.disabled; })[0];
      if (match) {
        sel.value = match.value;
        sel.classList.remove('is-asking');
        /* Pressed by her: the maatcoach leaves it, unless she asks the coach again. */
        if (!onlyEmpty) sel.setAttribute('data-own', '');
      }
    });
    var hint = $('[data-size-hint]', panel);
    if (hint && text('size-saved')) hint.hidden = false;
  }
  function recall(panel) {
    var m = remembered();
    $$('[data-size-row]', panel).forEach(function (row) {
      var want = m[row.getAttribute('data-size-row')];
      if (!want || $('[data-size-pick][aria-pressed="true"]', row)) return;
      var btn = $$('[data-size-pick]', row).filter(function (b) { return b.getAttribute('data-size-pick') === want; })[0];
      if (btn) pick(panel, btn, true);
    });
  }

  /* ---- the maatcoach for the whole outfit (28-10-2026) ------------------------------------------------------------- */
  /* Eigenaar: "De nieuwe maatcoach moeten we ook nog eens gaan toevoegen bij the looks ... Klant vult daar dus eenmalig haar
     gegevens en alle data wordt dan aangevuld". Under the sizes one quiet line, "My recommended sizes": it opens the
     maatcoach in its own pop-up (snippets/maatcoach.liquid, context look; assets/maatcoach.js), she answers once, and every
     piece takes the size its own chart gives her, the advice of its product page (sections/mc-data.liquid, the same request
     as mcFetch in assets/theme.js). With answers from before (a product page, the menu) the sizes are filled in as soon as
     the panel opens. A size she chose herself stays, unless she answers the coach again; a size sold out in the colour of
     the look is never chosen, and the piece says so. */
  var coach = document.querySelector('[data-mc-look-dialog]');
  var coachBox = coach && coach.querySelector('[data-mc-look]');
  var coachFor = null;
  var MS = {};
  try {
    MS = JSON.parse(coachBox.querySelector('script[data-mc-strings]').textContent);
    /* The t filter hands over escaped text; decode once, as assets/maatcoach.js does. */
    var decoder = document.createElement('textarea');
    Object.keys(MS).forEach(function (k) {
      if (typeof MS[k] !== 'string') return;
      decoder.innerHTML = MS[k];
      MS[k] = decoder.value;
    });
  } catch (e) { coach = null; }
  var mcData = {};
  function mcFetch(handle) {
    if (!mcData[handle]) {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      mcData[handle] = fetch(base + 'products/' + encodeURIComponent(handle) + '?section_id=mc-data', { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var node = html && new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-mc-data]');
          return node ? JSON.parse(node.textContent) : null;
        })
        .catch(function () { return null; });
    }
    return mcData[handle];
  }
  /* The pieces with a size to choose, with their handle from the link to their page. */
  function mcPieces(panel) {
    return $$('[data-piece]', panel).map(function (row) {
      var sel = $('[data-piece-size]', row);
      var link = $('.lk-piece__name', row);
      var m = link && (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!sel || !m || row.hasAttribute('data-accent')) return null;
      return { row: row, sel: sel, handle: decodeURIComponent(m[1]), name: link.textContent.trim() };
    }).filter(Boolean);
  }
  function mcAvail(sel) {
    return $$('option[data-size]', sel).filter(function (o) { return !o.disabled; }).map(function (o) { return o.getAttribute('data-size'); });
  }
  /* assets/maatcoach.js comes after this script (both deferred): a look opened from a collection tile (#look-r3-08) opens
     before the engine is there, so it waits for the page to be ready. */
  function mcEngine(then) {
    var ready = function () { return window.Maatcoach && window.Maatcoach.profile; };
    if (ready()) { then(window.Maatcoach); return; }
    var done = false;
    var go = function () { if (!done && ready()) { done = true; then(window.Maatcoach); } };
    document.addEventListener('DOMContentLoaded', go);
    window.addEventListener('load', go);
  }
  /* The line under the sizes: before the answers "My recommended sizes", after them "Sizes recommended for you" with
     "Edit"; both open the coach. */
  function mcLine(panel, done) {
    var wrap = $('[data-look-sizes]', panel);
    if (!coach || !wrap) return;
    var line = $('.lk-mc', wrap);
    if (!line) {
      line = document.createElement('p');
      line.className = 'lk-mc';
      wrap.appendChild(line);
    }
    line.innerHTML = '';
    line.classList.toggle('is-done', !!done);
    if (done) {
      var words = document.createElement('span');
      words.className = 'lk-mc__done';
      words.textContent = MS.lookDone;
      line.appendChild(words);
    }
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lk-mc__open';
    b.setAttribute('data-lk-mc', '');
    b.setAttribute('aria-haspopup', 'dialog');
    b.setAttribute('aria-controls', coach.id);
    b.textContent = done ? MS.hintEdit : MS.lookFind;
    line.appendChild(b);
  }
  /* Her size on every piece; force (she just answered in the coach) also replaces a size she chose herself. */
  function mcAdvise(panel, force) {
    var MC = window.Maatcoach;
    if (!coach || !MC || !MC.profile) return;
    var profile = MC.profile();
    if (!MC.body(profile) && !(Number(profile.shoe) > 0)) { mcLine(panel, false); return; }
    var list = mcPieces(panel);
    Promise.all(list.map(function (p) { return mcFetch(p.handle); })).then(function (datas) {
      if (panel !== current) return;
      var any = false;
      list.forEach(function (p, i) {
        var a = datas[i] ? MC.analyse(datas[i]) : null;
        var res = a ? MC.advise(a, profile) : null;
        var pick = res && res.status === 'ok' && res.pick != null ? String(res.pick) : '';
        var old = $('.lk-mc-piece', p.row);
        if (old) old.parentNode.removeChild(old);
        if (!pick) return;
        any = true;
        var opt = $$('option[data-size]', p.sel).filter(function (o) { return o.getAttribute('data-size') === pick; })[0];
        var sold = !opt || opt.disabled;
        if (!sold && (force || !p.sel.hasAttribute('data-own'))) {
          p.sel.value = opt.value;
          p.sel.classList.remove('is-asking');
        }
        if (force) p.sel.removeAttribute('data-own');
        var txt = $('.lk-piece__txt', p.row);
        if (txt) {
          var note = document.createElement('span');
          note.className = 'lk-mc-piece' + (sold ? ' is-sold' : '');
          note.textContent = String((a.kind === 'shoe' ? MS.adviceForShoe : MS.adviceFor) || '%size%').replace('%size%', pick) + (sold ? ' · ' + MS.hintSold : '');
          txt.appendChild(note);
        }
      });
      /* Per piece now, so the size for the whole outfit is no longer pressed. */
      if (force && any) $$('[data-size-pick]', panel).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      mcLine(panel, any);
      update(panel);
    });
  }
  /* The coach for this outfit: the pieces with their charts first (assets/maatcoach.js, box.mcLook), then the pop-up over the
     panel. */
  function openCoach(panel) {
    if (!coach || !coachBox) return;
    var list = mcPieces(panel);
    Promise.all(list.map(function (p) { return mcFetch(p.handle); })).then(function (datas) {
      var MC = window.Maatcoach;
      if (!MC || panel !== current) return;
      coachBox.mcLook = {
        pieces: list.map(function (p, i) {
          var a = datas[i] ? MC.analyse(datas[i]) : null;
          return { name: p.name, data: datas[i], shoe: !!a && a.kind === 'shoe', avail: mcAvail(p.sel) };
        })
      };
      coachFor = panel;
      if (coach.showModal) { if (!coach.open) coach.showModal(); } else coach.setAttribute('open', '');
    });
  }
  if (coach) {
    document.addEventListener('maatcoach:change', function () {
      if (current) mcAdvise(current, coach.open && coachFor === current);
    });
    /* The charts load while her finger is on the line, so the pop-up opens without waiting. */
    root.addEventListener('pointerdown', function (e) {
      if (current && e.target.closest && e.target.closest('[data-lk-mc]')) mcPieces(current).forEach(function (p) { mcFetch(p.handle); });
    }, { passive: true });
  }

  /* A piece shown in place of the look (eigenaar 27-10-2026: "wanneer klant klikt op een kledingstuk de foto van de outfit
     naar de foto van kledingstuk te veranderen ... zo blijft klant op de pagina"; then "teveel lelijke opvulling, foto moet
     duidelijk in beeld, elegant, fix verhouding"): its photo (data-piece-img) on its own proportion over the full width,
     never cut and without bands, and under it a quiet card with the name, colour and price, "Le look" back and "Voir la
     fiche" to its page. The elements are made once per panel, the first time; the photo loads on the first hover (desktop)
     or the click, and the card changes with the photo, so the two always match. */
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function viewer(panel) {
    var media = $('[data-look-media]', panel);
    if (!media || $('.lk-panel__piece', media)) return media;
    var img = document.createElement('img');
    img.className = 'lk-panel__piece';
    img.alt = '';
    img.decoding = 'async';
    img.addEventListener('load', function () {
      if (media.classList.contains('is-viewing') && media.__row) caption(media, media.__row);
    });
    var card = document.createElement('div');
    card.className = 'lk-view';
    card.innerHTML = '<p class="lk-view__name"></p><p class="lk-view__meta"></p><p class="lk-view__links">'
      + '<button type="button" class="lk-view__back" data-look-back></button><a class="lk-view__link" data-piece-page></a></p>';
    $('[data-look-back]', card).textContent = text('back');
    $('[data-piece-page]', card).textContent = text('piece-page');
    media.appendChild(img);
    media.appendChild(card);
    return media;
  }
  function caption(media, row) {
    var name = $('.lk-piece__name', row);
    var colour = $('.lk-piece__colour', row);
    var price = $('.lk-piece__price', row);
    $('.lk-view__name', media).textContent = name ? name.textContent : '';
    var meta = $('.lk-view__meta', media);
    meta.textContent = colour ? colour.textContent : '';
    if (price) meta.appendChild(price.cloneNode(true));
    var page = $('[data-piece-page]', media);
    if (name) { page.href = name.href; page.setAttribute('aria-label', text('piece-page') + ' : ' + name.textContent); }
    $('.lk-panel__piece', media).alt = name ? name.textContent : '';
    media.classList.add('is-piece');
  }
  function showPiece(panel, row) {
    var url = row.getAttribute('data-piece-img');
    var media = url && viewer(panel);
    if (!media) return false;
    if (row.classList.contains('is-shown')) { showLook(panel); return true; }
    $$('.lk-piece.is-shown', panel).forEach(function (r) { r.classList.remove('is-shown'); });
    row.classList.add('is-shown');
    media.__row = row;
    media.classList.add('is-viewing');
    var img = $('.lk-panel__piece', media);
    if (img.getAttribute('src') === url && img.complete) caption(media, row);
    else img.src = url;
    /* On the phone the photo is at the top of the sheet. */
    if (panel.scrollTop > 0 && panel.scrollHeight > panel.clientHeight + 1) panel.scrollTo({ top: 0, behavior: calm ? 'auto' : 'smooth' });
    return true;
  }
  function showLook(panel) {
    $$('.lk-piece.is-shown', panel).forEach(function (r) { r.classList.remove('is-shown'); });
    var media = $('[data-look-media]', panel);
    if (media) { media.classList.remove('is-piece', 'is-viewing'); media.__row = null; }
  }
  root.addEventListener('pointerover', function (e) {
    var row = e.target.closest && e.target.closest('[data-piece-img]');
    if (!row || row.hasAttribute('data-preloaded')) return;
    row.setAttribute('data-preloaded', '');
    var i = new Image();
    i.decoding = 'async';
    i.src = row.getAttribute('data-piece-img');
  });

  function open(card, fromHash) {
    var panel = $('[data-look-panel]', card);
    if (!panel || !dialog || !slot) return;
    if (current) putBack();
    home = card;
    current = panel;
    slot.appendChild(panel);
    panel.hidden = false;
    $$('img[loading="lazy"]', panel).forEach(function (img) { img.loading = 'eager'; });
    sizes(panel);
    recall(panel);
    showLook(panel);
    update(panel);
    if (coach) {
      mcLine(panel, false);
      mcEngine(function () { mcAdvise(panel, false); });
    }
    /* Cart.add writes its errors in the first [data-product-error]: that is the open panel. */
    $$('[data-product-error]', root).forEach(function (el) { el.removeAttribute('data-product-error'); });
    var err = $('[data-look-error]', panel);
    if (err) { err.textContent = ''; err.setAttribute('data-product-error', ''); }
    if (dialog.showModal) { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute('open', '');
    document.documentElement.classList.add('lk-locked');
    var scroll = $('.lk-panel__scroll', panel);
    if (scroll) scroll.scrollTop = 0;
    panel.scrollTop = 0;
    if (!fromHash && card.id && window.history.replaceState) window.history.replaceState(null, '', '#' + card.id);
  }
  function putBack() {
    if (!current) return;
    current.hidden = true;
    home.appendChild(current);
    current = null;
  }
  if (dialog) {
    dialog.addEventListener('close', function () {
      var card = home;
      putBack();
      document.documentElement.classList.remove('lk-locked');
      if (window.history.replaceState && /^#look-/.test(window.location.hash)) window.history.replaceState(null, '', window.location.pathname + window.location.search);
      if (card) { var btn = $('.lk__open', card); if (btn) btn.focus({ preventScroll: true }); }
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }
  root.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-look-open]');
    if (opener) { open(opener.closest('[data-look]')); return; }
    if (e.target.closest('[data-look-close]')) { if (dialog && dialog.open) dialog.close(); return; }
    /* A piece: its photo in place of the look; with ctrl, cmd or shift the link opens as usual. */
    var piece = current && e.target.closest('.lk-piece__img, .lk-piece__name');
    if (piece && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) {
      var prow = piece.closest('[data-piece]');
      if (prow && showPiece(current, prow)) { e.preventDefault(); return; }
    }
    if (current && e.target.closest('[data-look-back]')) { showLook(current); return; }
    if (current && e.target.closest('[data-lk-mc]')) { openCoach(current); return; }
    var chip = e.target.closest('[data-size-pick]');
    if (chip && current) {
      pick(current, chip, false);
      var row = chip.closest('[data-size-row]');
      if (row) remember(row.getAttribute('data-size-row'), chip.getAttribute('data-size-pick'));
      update(current);
    }
  });
  root.addEventListener('change', function (e) {
    var panel = e.target.closest('[data-look-panel]');
    if (!panel) return;
    if (e.target.matches('[data-piece-size]')) {
      e.target.classList.remove('is-asking');
      /* Chosen by her: the maatcoach leaves it, unless she answers the coach again. */
      if (e.isTrusted) e.target.setAttribute('data-own', '');
    }
    update(panel);
  });

  /* Every checked piece needs a size before the theme adds the outfit (capture: before its handler on the document). */
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-look-form]');
    if (!form) return;
    var missing = $$('[data-piece-size]', form).filter(function (s) { return !s.disabled && !s.value; });
    if (!missing.length) return;
    e.preventDefault();
    e.stopPropagation();
    missing.forEach(function (s) { s.classList.remove('is-asking'); void s.offsetWidth; s.classList.add('is-asking'); });
    missing[0].focus();
    var err = $('[data-look-error]', form);
    if (err) err.textContent = text('choose');
  }, true);

  /* The drawer of the theme opens after an add: the dialog steps aside so the drawer is in view. */
  var drawer = document.querySelector('[data-drawer]');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (drawer.classList.contains('is-open') && dialog && dialog.open) dialog.close();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* From a collection tile: /pages/looks#look-r3-08 opens that look, with the others around it. */
  var hash = window.location.hash;
  if (/^#look-[\w-]+$/.test(hash)) {
    var target = document.getElementById(hash.slice(1));
    if (target && target.hasAttribute('data-look')) {
      target.classList.add('is-target');
      target.scrollIntoView({ block: 'center' });
      open(target, true);
    }
  }
})();
